export default __webpack_public_path__ + "static/media/Ballroll_00278.a7d74021.png";